import { AxiosResponse, CancelToken } from "axios";
import http from "../../../../shared/http";
import { ReadPackagesRequestDto, ReadPackagesResponseDto } from "./dtos";

export const listPackages = async (
  { _query }: ReadPackagesRequestDto,
  cancelToken: CancelToken
): Promise<AxiosResponse<ReadPackagesResponseDto>> => {
  //POST because too complicated request list
  return await http.post<ReadPackagesResponseDto>(`/packages`, _query, {
    cancelToken,
  });
};
